/**
 * Nach einem Deploy existieren die alten, gehashten JS-Chunks nicht mehr.
 * Eine noch offene Seite (oder die Home-Bildschirm-Web-App mit altem
 * Service-Worker-Stand) scheitert dann beim Lazy-Import einer Page mit
 * "Importing a module script failed" (Safari) bzw. "Failed to fetch
 * dynamically imported module" (Chrome) — und bleibt leer.
 *
 * Lösung: einmal neu laden, dann holt der Browser das neue index.html mit
 * den aktuellen Chunk-Namen. Der Zeitstempel in sessionStorage verhindert
 * eine Reload-Schleife, falls der Fehler eine andere Ursache hat.
 */
const STORAGE_KEY = 'chunk-reload-at'
const MIN_INTERVAL_MS = 10_000

const CHUNK_ERROR_PATTERNS = [
  /Importing a module script failed/i,
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Unable to preload CSS/i,
]

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '')
  return CHUNK_ERROR_PATTERNS.some((re) => re.test(message))
}

/** Lädt die Seite neu, höchstens einmal pro 10 s. true = Reload ausgelöst. */
export function reloadForStaleChunk(now: number = Date.now()): boolean {
  try {
    const last = Number(window.sessionStorage.getItem(STORAGE_KEY) ?? 0)
    if (now - last < MIN_INTERVAL_MS) return false
    window.sessionStorage.setItem(STORAGE_KEY, String(now))
  } catch {
    // sessionStorage gesperrt (Privatmodus): trotzdem einmal neu laden.
  }
  window.location.reload()
  return true
}
